import { FileUp, BrainCircuit, FileCheck2 } from "lucide-react";

const STEPS = [
  {
    id: 1,
    icon: FileUp,
    title: "Upload PDF",
    description:
      "Sleep je energiecontract als PDF in onze beveiligde upload. Optioneel ook je jaarafrekening voor extra accuratie.",
  },
  {
    id: 2,
    icon: BrainCircuit,
    title: "Diepgaande analyse",
    description:
      "Onze experts lezen het contract als een jurist. Letterlijk elke clausule, terugleververgoeding en kleine letter — binnen 30 seconden.",
  },
  {
    id: 3,
    icon: FileCheck2,
    title: "Rapport + brieven",
    description:
      "Je krijgt een helder rapport met besparingen, risico's en kant-en-klare brieven (opzegging, klacht, bezwaar).",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="hoe-werkt-het"
      className="border-t border-slate-200 bg-white"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-24">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">
            Hoe werkt het
          </span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
            Van PDF naar besparing in drie stappen.
          </h2>
          <p className="mt-3 text-slate-600">
            Geen formulieren, geen vergelijkers, geen sales-praatjes. Gewoon: jouw contract → jouw eerlijk rapport.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {STEPS.map((s) => (
            <div
              key={s.id}
              className="bg-white border border-slate-200 rounded-2xl p-7 hover:border-blue-200 hover:shadow-[0_8px_30px_-12px_rgba(15,23,42,0.12)] transition-all"
              data-testid={`how-step-${s.id}`}
            >
              <div className="flex items-start justify-between mb-5">
                <div className="h-11 w-11 rounded-xl bg-blue-50 border border-blue-100 grid place-items-center">
                  <s.icon className="h-5 w-5 text-blue-700" />
                </div>
                <span className="font-heading text-3xl font-bold text-slate-200">
                  0{s.id}
                </span>
              </div>
              <h3 className="font-heading text-xl font-semibold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-slate-600 leading-relaxed">{s.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
